<template>
	<div>
		<Form @submit.native.prevent="preventSubmit" :model="queryForm" inline>
			<Row>
				<FormItem label="结算月份：" prop="curYearMonth" :label-width="100">
					<Select v-model="queryForm.curYearMonth" style="width: 160px" transfer>
						<Option :value="-1">全部</Option>
						<Option v-for="item in yearMonthDate" :key="item.curYearMonth" :value="item.curYearMonth">{{item.curYearMonth}}</Option>
					</Select>
				</FormItem>
				<FormItem label="业主：" prop="owner" :label-width="100">
					<Input type="text" placeholder="搜索业主姓名、手机号" v-model="queryForm.owner" :maxlength="20"></Input>
				</FormItem>
				<FormItem label="账单状态：" prop="isImported" :label-width="100">
					<Select v-model="queryForm.isImported" style="width: 160px">
						<Option :value="-1">全部</Option>
						<Option :value="0">未结算</Option>
						<Option :value="1">已结算</Option>
						<Option :value="2">已打款</Option>
					</Select>
				</FormItem>
			</Row>
			<Row>
				<FormItem prop="query">
					<Button type="primary" @click="changePage(1)">查询</Button>
				</FormItem>
				<FormItem prop="export">
					<Button type="primary" @click="()=>exportRoomReport()" :loading="exportBtn">导出筛选结果</Button>
				</FormItem>

			</Row>
		</Form>
		<Table stripe :loading="loading" ref="roomsTable" :columns="columns" :data="roomsData.result"></Table>
		<div class="add-distance">
			<Page show-sizer placement="top" :total="roomsData.count" :current="page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
		</div>
	</div>
</template>

<script>
import Utils from "../../../utils";
import config from '../../../config';

export default {
	created() {
		this.env = Utils.findFromLocalStorage( "env", "dev" );
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
	},
	data() {
		// 转换 元
		const toCurrency = ( money ) => {
			return Number( money ) || money == 0 ? ( money / 100 ).toFixed( 2 ) : '--'
		}

		// 转换格式
		const toCashier = ( h, systemData, importData ) => {
			return [
				h( "div", {}, `系统：${ toCurrency( systemData ) }` ),
				h( "div", {}, `导入：${ toCurrency( importData ) }` )
			]
		}

		const toDes = ( h, systemData, adjustData, importData ) => {
			return [
				h( 'div', {}, `系统：${ toCurrency( systemData ) }` ),
				h( 'div', {}, `调整：${ toCurrency( adjustData ) }` ),
				h( 'div', {}, `导入：${ toCurrency( importData ) }` ),
			]
		}


		return {
			exportBtn: false,
			// 查询表单条件
			queryForm: {
				curYearMonth: -1, // 结算月份
				owner: '', // 业主
				isImported: -1 // 结算状态
			},
			// 表格loading
			loading: false,
			// 表格列
			columns: [
				{
					title: "账单id",
					key: "id",
					align: "center",
					width: 100
				},
				{
					title: "月份",
					key: "curYearMonth",
					align: "center",
					width: 100
				},
				{
					title: "结算状态",
					align: "center",
					width: 100,
					render: ( h, params ) => {
						let imported = ['未结算', '已结算', '已打款'][params.row.imported]
						return h( "div", {}, imported );
					}
				},
				{
					title: "业主",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						// return h("div", {}, `${params.row.owner}-${params.row.ownerPhone}`);     无owner字段
						return h( "div", {}, `${ params.row.ownerName }-${ params.row.ownerPhone }` );
					}
				},
				{
					title: "房间数",
					key: 'roomNumber',
					align: "center",
					width: 100
				},
				{
					title: "已结算房间数",
					key: "importedRoomNumber",
					align: "center",
					width: 120
				},
				{
					title: "房费原价",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.roomOriMoney, params.row.checkRoomOriMoney))
						return h( 'div', toDes( h, params.row.roomOriMoney, params.row.adjustRoomOriMoney, params.row.checkRoomOriMoney ) )
					}
				},
				{
					title: "业主优惠",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.ownerDiscount, params.row.checkOwnerDiscount))
						return h( 'div', toDes( h, params.row.ownerDiscount, params.row.adjustOwnerDiscount, params.row.checkOwnerDiscount ) )
					}
				},
				{
					title: "结算房费（消费额）",
					align: "center",
					width: 180,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.roomSettleMoney, params.row.checkRoomSettleMoney))
						return h( 'div', toDes( h, params.row.roomSettleMoney, params.row.adjustRoomSettleMoney, params.row.checkRoomSettleMoney ) )
					}
				},

				{
					title: "OTA佣金",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.channelCommission, params.row.checkChannelCommission))
						return h( 'div', toDes( h, params.row.channelCommission, params.row.adjustChannelCommission, params.row.checkChannelCommission ) )
					}
				},
				{
					title: "渠道活动费",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.otherChannelExpenses, params.row.checkOtherChannelExpenses))
						return h( 'div', toDes( h, params.row.otherChannelExpenses, params.row.adjustOtherChannelExpenses, params.row.checkOtherChannelExpenses ) )
					}
				},

				// {
				//   title: "渠道佣金",
				//   align: "center",
				//   width: 120,
				//   render: (h, params) => {
				//     return h('div', toCashier(h, params.row.otaPlatformMoney, params.row.checkOtaplatformMoney))
				//   }
				// },
				{
					title: "业主推广费",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.ownerPromotionExpense, params.row.checkOwnerPromotionExpense))
						return h( 'div', toDes( h, params.row.ownerPromotionExpense, params.row.adjustOwnerPromotionExpense, params.row.checkOwnerPromotionExpense ) )
					}
				},
				{
					title: "平台服务费",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						// return h('div', toCashier(h, params.row.xbedPlatformMoney, params.row.checkXbedPlatformMoney))
						return h( 'div', toDes( h, params.row.xbedPlatformMoney, params.row.adjustXbedPlatformMoney, params.row.checkXbedPlatformMoney ) )
					}
				},
				{
					title: "推广费返还",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						// return h('div', {}, toCashier(h, params.row.promotionExpenseBack, params.row.checkPromotionExpenseBack))
						return h( 'div', toDes( h, params.row.promotionExpenseBack, params.row.adjustPromotionExpenseBack, params.row.checkPromotionExpenseBack ) )
					}
				},
				{
					title: "开发费返还",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', {}, toCashier( h, params.row.devFeeBack, params.row.checkDevFeeBack ) )
					}
				},
				{
					title: "其它收入",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.otherIncome ) }` )
					}
				},
				{
					title: "第三方结算费",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.transactionFee ) }` )
					}
				},
				{
					title: "税费",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.invoiceTax ) }` )
					}
				},

				{
					title: "地面销售费用",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.groundSaleFee ) }` )
					}
				},
				{
					title: "基础导流佣金",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.unoccupiedCommission ) }` )
					}
				},

				{
					title: "清洁单费",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', toCashier( h, params.row.cleanMoney, params.row.checkCleanMoney ) )
					}
				},
				{
					title: "易耗品费",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						return h( 'div', toCashier( h, params.row.consumableMoney, params.row.checkConsumableMoney ) )
					}
				},
				{
					title: "洗涤费",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', toCashier( h, params.row.linenWashMoney, params.row.checkLinenWashMoney ) )
					}
				},
				{
					title: "运营服务费",
					align: "center",
					width: 150,
					render: ( h, params ) => {
						return h( 'div', {}, toCashier( h, params.row.operatingExpenses, params.row.checkOperatingExpenses ) )
					}
				},
				{
					title: "促销费返还",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', {}, toCashier( h, params.row.saleFeeBack, params.row.checkSaleFeeBack ) )
					}
				},
				{
					title: "其它杂项费",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', {}, toCurrency( params.row.miscellaneousExpenses ) )
					}
				},
				{
					title: "上月结余",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', {}, `系统：${ toCurrency( params.row.lastMonthBalance ) }` )
					}
				},
				{
					title: "本月可提现",
					align: "center",
					width: 130,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.roomPresented ) }` )
					}
				},
				{
					title: "实际打款金额",
					align: "center",
					width: 180,
					render: ( h, params ) => {
						return h( 'div', {}, `导入：${ toCurrency( params.row.actualTransferAmount ) }` )
					}
				}
			],
			page: 1, // 页码
			pageSize: 10, // 每页数量
		}
	},
	props: {
		// 房间列表相关数据
		roomsData: {
			type: Object,
			default() {
				return {
					count: 0,
					result: []
					// list: []
				}
			}
		},
		// 年月数据
		yearMonthDate: {
			type: Array,
			default() {
				return []
			}
		}
	},
	watch: {
		// 初始化结算月份
		yearMonthDate( val ) {
			val.length > 0 && ( this.queryForm.curYearMonth = val[0].curYearMonth )
		}
	},
	methods: {

		//导出业主报表
		// @param 导出的类型
		exportRoomReport() {
			let params = {
				curYearMonth: this.queryForm.curYearMonth,    //结算月份 string
				owner: this.queryForm.owner,          //业主(搜索业主姓名、手机号) string
				page: this.page,        //页数 number
				size: this.pageSize,        //每页行数 number
			}

			//0 未结算，1 已结算，2已打款 number
			this.queryForm.isImported !== -1 && ( params.isImported = this.queryForm.isImported )

			// 如果选全部月份
			this.queryForm.curYearMonth !== -1 && ( params.curYearMonth = this.queryForm.curYearMonth )

			//导出报表
			const exportUrl = 'excel/exportOwnerRoomMonth?';
			let finalUrl = config[this.env].analysisUrl + exportUrl;
			for ( let key in params ) {
				var value = params[key];
				if ( key !== 'isImported' || value !== null ) {
					// if((key !== 'isImported' || value !== null) && key !== 'page' && key !== 'size'){
					finalUrl += ( finalUrl.indexOf( '?' ) >= 0 ? '&' : '?' ) + key + '=' + value
				}
			}
			// window.open(finalUrl ,"_blank");
			Utils.exportExcelWeighting( finalUrl, this.token, this.$Notice.error, this, "exportBtn" )

		},

		//改变页数
		changePage( page ) {
			this.page = page
			this.quertReport()
		},
		//改变每页显示数量
		changePageSize( pageSize ) {
			this.page = 1
			this.pageSize = pageSize
			this.quertReport()
		},
		//查询报表
		quertReport() {
			this.loading = true;
			let forms = Object.assign( {}, this.queryForm );

			//0 未结算，1 已结算，2已打款 number
			forms.isImported === -1 && ( delete forms.isImported )

			// 如果选全部月份
			forms.curYearMonth === -1 && ( delete forms.curYearMonth )

			this.$emit( 'queryReportData', {
				page: this.page,
				size: this.pageSize,
				...forms
			}, () => {
				this.loading = false;
			} )
		},
		// 阻止form回车提交事件
		preventSubmit() {
			return false;
		},
	}
}
</script>

<style lang="scss" scoped>
.add-distance {
	margin-top: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/report/owner-revenue/owner-revenue.vue